export default "__VITE_ASSET__CTNiNzD___"